export type DeltaBadgeProps = {
  value: number;
  avg?: number | null;
  label?: string;
  className?: string;
};

export function DeltaBadge({
  value,
  avg,
  label = "vs your 3-session avg",
  className = "",
}: DeltaBadgeProps) {
  if (avg == null) return null;
  const delta = +(value - avg).toFixed(1);
  const base =
    "ml-2 text-xs rounded px-2 py-0.5 align-middle inline-flex items-center whitespace-nowrap " +
    className;

  if (delta === 0) {
    return (
      <span className={`${base} border text-muted-foreground`}>= {label}</span>
    );
  }

  const up = delta > 0;
  return (
    <span
      className={
        base +
        (up
          ? " bg-emerald-50 text-emerald-700 border border-emerald-200"
          : " bg-amber-50 text-amber-700 border border-amber-200")
      }
      title="Compared to your last 3 encounters"
    >
      {up ? "▲" : "▼"} {Math.abs(delta)} {label}
    </span>
  );
}
